import moment from 'moment'
import { DateRangePicker } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'
import { requestArgsDateRange } from './columnsReqArgs'

export class MedBirthCertificateDateColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.MED_BIRTH_CERTIFICATE_DATE

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Дата выдачи МСР',
        component: DateRangePicker,
        defaultValue: [null, null],
        props: {
          allowEmpty: [true, true],
          allDay: true,
          disabledDate: currentDate => currentDate && currentDate.isAfter(moment()),
        },
      },
      width: 250,
      dataIndex: 'med_birth_certificate_date',
      dataRender: date => date ? moment(date).format('DD.MM.YYYY') : '-',
      sort: true,
    }

    super(column, settings)
  }

  _requestArgs = reqArgs => requestArgsDateRange(this.type, reqArgs)
}
